import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { UserAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import { PolicySignoffListing, PolicyListing } from 'pages/policy/listing';
import { PoliciesLayout } from 'pages/policy';

export function Policies(props) {

    return (
        <UserAccess perform={["Documents:View"]}
            yes={() => (
                <PoliciesLayout breadcrumbs={props.breadcrumbs}>
                    <Routes>
                        <Route path="policies" element={<PolicyListing />} />
                        <Route path="policies-signoff" element={<PolicySignoffListing title={"Policy Sign-off"} />} />
                        <Route path="" element={<Navigate to="/policy-management/policies" replace />} />
                    </Routes>
                </PoliciesLayout>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}